import './styles/quasar.scss'
import lang from 'quasar/lang/es.js'
import '@quasar/extras/material-icons/material-icons.css'
import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    // Configuracion para mejorar scroll en iOS
    brand: {
      primary: '#1976d2',
      secondary: '#26A69A',
      accent: '#9C27B0',
      dark: '#1d1d1d',
      positive: '#21BA45',
      negative: '#C10015',
      info: '#31CCEC',
      warning: '#F2C037'
    },
    // Habilitar scroll suave
    scrollBehavior: 'smooth'
  },
  plugins: {
    Notify,
    Dialog,
    Loading
  },
  lang: lang
}